import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from 'recharts';

export interface ChartBarConfig {
  dataKey: string;
  fill: string;
  name: string;
  stackId?: string;
}

interface ChartProps {
  data: any[];
  bars: ChartBarConfig[];
  height?: number;
  showLegend?: boolean;
  layout?: 'horizontal' | 'vertical';
  margin?: { top: number; right: number; left: number; bottom: number };
  xAxisKey?: string;
  xAxisType?: 'number' | 'category';
  yAxisType?: 'number' | 'category';
  hideXAxis?: boolean;
  hideYAxis?: boolean;
  xAxisDomain?: [number, number];
  tooltipFormatter?: (value: any) => string;
  ariaLabel?: string;
}

/**
 * Reusable Chart component that wraps recharts BarChart
 * Supports both horizontal and vertical layouts, stacking, and custom styling
 */
const Chart = ({
  data,
  bars,
  height = 250,
  showLegend = true,
  layout = 'horizontal',
  margin = { top: 5, right: 20, left: -10, bottom: 5 },
  xAxisKey = 'name',
  xAxisType,
  yAxisType,
  hideXAxis = false,
  hideYAxis = false,
  xAxisDomain,
  tooltipFormatter,
  ariaLabel,
}: ChartProps) => {
  return (
    <div role="img" aria-label={ariaLabel}>
      <ResponsiveContainer width="100%" height={height}>
        <BarChart data={data} margin={margin} layout={layout}>
        {!hideXAxis && (
          <XAxis
            dataKey={layout === 'horizontal' ? xAxisKey : undefined}
            type={xAxisType || (layout === 'horizontal' ? 'category' : 'number')}
            tick={{ fontSize: 12 }}
            hide={hideXAxis}
            domain={xAxisDomain}
          />
        )}
        {!hideYAxis && (
          <YAxis
            dataKey={layout === 'vertical' ? xAxisKey : undefined}
            type={yAxisType || (layout === 'horizontal' ? 'number' : 'category')}
            tick={{ fontSize: 12 }}
            hide={hideYAxis}
          />
        )}
        <Tooltip formatter={tooltipFormatter} />
        {showLegend && <Legend wrapperStyle={{ fontSize: '12px' }} />}
        {bars.map((bar) => (
          <Bar
            key={bar.dataKey}
            dataKey={bar.dataKey}
            fill={bar.fill}
            name={bar.name}
            stackId={bar.stackId}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
    </div>
  );
};

export default Chart;
